import React, { useEffect, useState } from 'react';
import { arrayUnion, collection, doc, serverTimestamp, writeBatch } from 'firebase/firestore';
import { db } from '../../../shared/storage/firebase';

interface Props { isOpen: boolean; squadId: string; onClose: () => void; }

const AddStudentModal: React.FC<Props> = ({ isOpen, squadId, onClose }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => { if (!isOpen) { setName(''); setError(null); setSaving(false); } }, [isOpen]);
  if (!isOpen) return null;

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const displayName = name.trim();
    if (!displayName) { setError('Enter a student name.'); return; }
    setSaving(true); setError(null);
    try {
      const studentRef = doc(collection(db, 'users'));
      const batch = writeBatch(db);
      batch.set(studentRef, { id: studentRef.id, displayName, role: 'student', isAdmin: false, ogLevel: 1, squadIds: [squadId], museCash: 50, createdAt: serverTimestamp() });
      batch.update(doc(db, 'squads', squadId), { studentIds: arrayUnion(studentRef.id) });
      await batch.commit();
      onClose();
    } catch (err) {
      console.error('Failed to add student:', err);
      setError('Could not add the student. Please try again.');
    } finally { setSaving(false); }
  };

  return <div className="roster-modal-overlay" onMouseDown={onClose}>
    <div className="roster-modal" role="dialog" aria-modal="true" aria-labelledby="add-student-title" onMouseDown={e => e.stopPropagation()}>
      <button type="button" className="roster-modal-close" onClick={onClose} aria-label="Close">×</button>
      <h2 id="add-student-title">Add a student</h2>
      <p>Create a student profile and add it to this class.</p>
      <form onSubmit={submit}>
        <label htmlFor="new-student-name">Student name</label>
        <input id="new-student-name" value={name} onChange={e => { setName(e.target.value); setError(null); }} maxLength={100} autoFocus disabled={saving} placeholder="First and last name" />
        {error && <div className="roster-modal-error" role="alert">{error}</div>}
        <div className="roster-modal-actions"><button type="button" onClick={onClose} disabled={saving}>Cancel</button><button type="submit" className="roster-primary-btn" disabled={saving || !name.trim()}>{saving ? 'Adding…' : 'Add student'}</button></div>
      </form>
    </div>
  </div>;
};

export default AddStudentModal;
